import React from 'react';

import type { SxProps, Theme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

type Props = {
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

const StepInput = ({ label, value, onChange, sx }: Props) => {
  return (
    <TextField
      size="small"
      label={label}
      value={value}
      onChange={onChange}
      fullWidth
      sx={sx}
    />
  );
};

export default StepInput;
